"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useId = exports.randomId = void 0;
var react_1 = require("react");
function randomId() {
    return "mantine-" + Math.random().toString(36).substr(2, 9);
}
exports.randomId = randomId;
function useId(id, generateId) {
    if (generateId === void 0) { generateId = randomId; }
    var generatedId = react_1.useRef(generateId());
    return id || generatedId.current;
}
exports.useId = useId;
